import React from 'react';
import GetInboundEmail from '../../messaging/getInboundEmail.jsx';
import RaisedButton from '../../tc-ui/raised-button-with-loader';

const EmailForwarding = () => {
  return (
    <div>
      <div style={{ paddingBottom: '12px', borderBottom: '1px solid #e6e9ec', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ fontSize: '24px', fontWeight: 400 }}>Forwarding Address</div>
        <div style={{ display: 'flex', alignItems: 'center' }}/>
      </div>
      <div style={{ marginTop: '20px' }}>
        <GetInboundEmail buttonStyle={{}} ButtonElement={ RaisedButton }/>
      </div>
    </div>
  );
};

export default EmailForwarding;



// WEBPACK FOOTER //
// ./src/app/components/settings/companySettings/email-forwarding.jsx